<template>
  <div id="snackbar" :class="{'show':show}">
    <img :src="`/img/covid-test/${icon}.svg`" alt="icon" />
    {{message}}
  </div>
</template>

<script>
export default {
  name: 'Toast',
  props:{
    icon: {
      type: String,
      default: 'Success'
    },
    message: {
      type: String
    }
  },
  data(){
    return{
      show: false
    }
  },
  watch:{
    show(value){
      if(value === true){
        setTimeout(()=>{
          this.show = false
        },3000)
      }
    }
  }
}
</script>

<style>
#snackbar {
  visibility: hidden;
  min-width: 250px;
  margin-left: -125px;
  background-color: #fff;
  box-shadow: 7px -7px 1px -4px #0000001f;
  border-radius: 2px;
  color: #000;
  text-align: center;
  border-radius: 2px;
  padding: 16px;
  position: fixed;
  z-index: 1;
  left: 50%;
  bottom: 30px;
  font-size: 17px;
  display: flex;
}

#snackbar.show {
  visibility: visible;
  animation: fadein 0.5s
}

@keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 30px; opacity: 1;}
}

@keyframes fadeout {
  from {bottom: 30px; opacity: 1;}
  to {bottom: 0; opacity: 0;}
}
@media screen and (max-width: 500px) {
  #snackbar {
    width: 100vw;
    margin-left: -175px;
  }
}
@media screen and (max-width: 414px) {
  #snackbar {
    margin-left: -208px;
  }
}
@media screen and (max-width: 375px) {
  #snackbar {
    margin-left: -188px;
  }
}
@media screen and (max-width: 360px) {
  #snackbar {
    margin-left: -181px;
  }
}
@media screen and (max-width: 320px) {
  #snackbar {
    margin-left: -162px;
  }
}
@media screen and (max-width: 280px) {
  #snackbar {
    margin-left: -142px;
  }
}
</style>